var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tournament-dashboard-wrapper"},[_c('div',{staticClass:"workspace"},[_vm._t("workspace")],2),_c('div',{staticClass:"sidebar"},[_vm._t("sidebar")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }